export const environment = {
  production: true,
  apiUrl: 'https://faip.servizi.mquadro.net/api/v1',
};

export const service_order = {
  production: true,
  defaultGridColumns: ['ods_id', 'extradata', 'start_date', 'end_date', 'ts_ods_start', 'ts_ods_end', 'assignedDriver', 'assignedLicensePlate', 'status', 'duration'],
  gridColumns: ['ods_id', 'assignedLicensePlate',  'description', 'start_date', 'end_date', 'ts_ods_start', 'ts_ods_end', 'duration',  'status', 'group', 'operations']
};
